import { render, staticRenderFns } from "./IndividualCustomerAccountCreation.vue?vue&type=template&id=704a57ba&"
import script from "./IndividualCustomerAccountCreation.vue?vue&type=script&lang=js&"
export * from "./IndividualCustomerAccountCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports